












import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { client } from "@/api/index";
import { localSet } from "@/utils/index";
import { handleResponse } from "@/utils/request";
import { LoginReq } from "@/pbjs/external/user/user_pb";

@Component({
  name: "googleAuth"
})
export default class GoogleAuth extends Vue {
    @Provide() private authCode: string = "";

    private closeAddDialog() {
        this.$emit("returnIsShow", 0);
    }

    private confirmSecondLogin() {
        this.$emit("commitTwoFactAuthCode", this.authCode);
    }
}
